/**
 * Shared embed message-type constants.
 *
 * Single source of truth for the `postMessage` `type` values exchanged between
 * embed iframes (this app) and the host page / unified loader. Import these
 * everywhere instead of hardcoding the string literals so the wire contract
 * can never drift between sender and receiver.
 */

/** Sent by an embed iframe to request a height resize on the host. */
export const EMBED_RESIZE_MESSAGE_TYPE = "gsf-embed-resize";

/** Sent by the guest-login embed iframe when it is dismissed/closed. */
export const EMBED_GUEST_LOGIN_CLOSE_MESSAGE_TYPE =
  "gsf-embed-guest-login-close";

/** Sent by a child embed iframe to open guest login on the host page. */
export const EMBED_GUEST_LOGIN_OPEN_MESSAGE_TYPE = "gsf-embed-guest-login-open";

/** Sent by the complete-profile embed when profile save finishes successfully. */
export const EMBED_COMPLETE_PROFILE_CLOSE_MESSAGE_TYPE =
  "gsf-embed-complete-profile-close";
